import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import DesignSolutionContent from "./DesignSolutionContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const DesignSolution = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("design.solution.seo.title")} description={t("design.solution.seo.des")} path="design/esg-design" />
      <TitleFormat text={t("design.solution.title")} />
      <DesignSolutionContent />
    </>
  );
};

export default DesignSolution;
